import accountsSaga from './accountsSaga';

export default accountsSaga;
